module.exports = __webpack_public_path__ + "img/anliimg.ea618e1b.png";